<template>
  <div class="formWrapper mb-5">
    <div class="formWrapper__header">
      <Icon icon="delivery" class="formWrapper__header__icon" />
      <h3>Punkty dostaw</h3>
    </div>
    <div class="formWrapper__inner">
      <ValidationProvider
        name="deliveryPointsInputMode"
        rules="required"
        v-slot="{ errors }"
        tag="div"
        class="mb-4"
      >
        <div class="delivery-input-mode">
          <label class="radio-tile">
            <input
              id="delivery-points-manual"
              v-model="inputMode"
              @change="handleManualModeSelection"
              type="radio"
              name="delivery-points-input-mode"
              value="manual"
            />
            <p class="radio-tile__title">
              Zamawiam na jeden adres
            </p>
            <p class="radio-tile__description">
              Wybierz tę opcję, kiedy całe zamówienie ma trafić na jeden adres.
            </p>
          </label>
          <label class="radio-tile">
            <input
              id="delivery-points-file"
              v-model="inputMode"
              type="radio"
              name="delivery-points-input-mode"
              value="file"
            />
            <p class="radio-tile__title">
              Zamawiam na wiele adresów
            </p>
            <p class="radio-tile__description">
              Wybierz tę opcję, kiedy zamówienie ma być dostarczone na więcej niż 1 adres.
            </p>
          </label>
        </div>
        <ul class="errors">
          <li class="text-danger" v-for="(error, idx) in errors" :key="idx">{{ error }}</li>
        </ul>
      </ValidationProvider>
      <div v-if="inputMode === 'file'">
        <delivery-points-file-form />
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import Icon from '@/components/Icon.vue';
import DeliveryPointsFileForm from './DeliveryPointsFileForm.vue';

export default {
  name: 'DeliveryPointsCountSelectForm',
  components: {
    Icon,
    DeliveryPointsFileForm,
  },
  computed: {
    ...mapFields('delivery', ['inputMode']),
  },
  methods: {
    handleManualModeSelection() {
      const deliveryAddressProduct = this.$store.getters.getDeliveryAddressProduct;

      if (!deliveryAddressProduct || !deliveryAddressProduct.idproducts) return;

      this.$store.dispatch('delivery/addProductToCart', {
        id: deliveryAddressProduct.idproducts,
        quantity: 1,
        price: parseFloat(deliveryAddressProduct.price) || 0,
        name: deliveryAddressProduct.name,
        iddelivery: 0,
        product_category: deliveryAddressProduct.product_category,
        analyticsData: deliveryAddressProduct.analyticsData,
      });

      this.$store.dispatch('cart/setDeliveryNumber', 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.delivery-input-mode {
  display: flex;
  gap: 0.8rem;
  flex-direction: column;

  > * {
    flex: 1;
  }

  @media (min-width: 1200px) {
    flex-direction: row;
    gap: 1.6rem;
  }
}
</style>
